import { IloanLogs } from "../../types/loan-logs-type";

const LOG_TITLE_CLASS =
  "flex-1 min-w-0 text-[13px] sm:text-[14px] font-medium text-heading-color text-start capitalize break-words";

// Renders optional reason suffix shared across log title variants
const renderReason = (reason?: string) =>
  reason ? (
    <span className="font-bold ml-[4px]">- ({reason})</span>
  ) : null;

// Renders creator name suffix when present
const renderCreator = (name?: string, leadingSpace = false) =>
  name ? (leadingSpace ? ` (${name})` : `(${name})`) : null;

// Appends SBV1 payment reference at end of journey payment logs
const renderSbv1PaymentReference = (item: IloanLogs) =>
  item?.type?.includes("sbv1") && item?.paymentRefference
    ? ` (${item.paymentRefference})`
    : null;

interface ChaseLogTitleProps {
  item: IloanLogs;
}

// Builds debt timeline log title text from log item type and metadata
const ChaseLogTitle = ({ item }: ChaseLogTitleProps) => {
  if (
    item.type === "payment-plan-collected" ||
    item.type === "payment-plan-failed-reattempting"
  ) {
    return (
      <h2 className={LOG_TITLE_CLASS}>
        {item?.paymentPlan === "full-payment-plan"
          ? "Full Payment Collected"
          : item.type.replaceAll("-", " ")}{" "}
        {item?.type === "payment-plan-failed-reattempting" ? (
          <>{item.attempt}</>
        ) : null}{" "}
        {item?.paymentPlan !== "full-payment-plan" &&
        item?.type !== "payment-plan-failed-reattempting" ? (
          <>
            {item.attempt} /{Number(item.paymentPlan?.split("-")[0]) || 1}
          </>
        ) : null}{" "}
        {renderReason(item?.reason)}
        {renderCreator(item?.creator?.name)}
      </h2>
    );
  }

  if (item?.type === "payment-plan-cancelled") {
    return (
      <h2 className={LOG_TITLE_CLASS}>
        {`${item?.paymentPlan?.split("-")[0]} Month Plan Cancelled`}
        {renderReason(item?.reason)}
        {renderCreator(item?.creator?.name, true)}
      </h2>
    );
  }

  if (item?.type === "debt-collectors-plan-collected") {
    return (
      <h2 className={LOG_TITLE_CLASS}>
        {item.type.replaceAll("-", " ")} {item?.attempt} /{" "}
        {item?.icbPaymentPlan?.replaceAll("-", " ").replace("plan", "")}
        {renderReason(item?.reason)}
        {renderCreator(item?.creator?.name, true)}
      </h2>
    );
  }

  return (
    <h2 className={LOG_TITLE_CLASS}>
      {item.type.replaceAll("-", " ").replaceAll("sbv1", "SBV1")}
      {renderReason(item?.reason)}
      {renderCreator(item?.creator?.name, true)}
      {renderSbv1PaymentReference(item)}
    </h2>
  );
};

export default ChaseLogTitle;
